import request from "./index";
export const getMessageList = async (shareId: any) => {
  return request({
    url: '/tools/share/get',
    method: 'GET',
    params: {
      shareId
    },
  })
}